<template>
	<section>
		<header-page
			actions
			name="account-definitions"
			:title="title"
			@run-action="runAction"
		/>
		<v-layout tabindex="-1">
			<v-flex>
				<v-alert
				:value="!currentSubsidiary.id" type="warning">
					Seleccione una empresa
				</v-alert>
			</v-flex>
		</v-layout>
		<accountDefinitionsAtsList
			v-if="currentSubsidiary.id"
			:items-total-quantity="itemsTotalQuantity"
			:items-quantity="rows.length"
			:current-page="params.page"
			:last-page="lastPage"
			:rows="rows"
			@click-icon="clickIcon"
			@on-page="onPage"
			@on-search="onSearch"
		>
		</accountDefinitionsAtsList>
		<action-bar
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<action-sidebar
			:title="action.title"
			:value="action.visible"
			@close-modal="closeModal"
		>
			<accountDefinitionsFormAts
				v-if="isAccountDefinitionForm"
				:subsidiary-id="selectedRow.subsidiaryId"
				:customer-id="selectedRow.customerId"
				:id="selectedRow.id"
				@close-modal="closeModal"
			/>
			<accountDefinitionsAtsRemove
				v-if="isAccountDefinitionRemove"
				:id="selectedRow.id"
				:name="selectedRow.name"
				@close-modal="closeModal"
			/>
			<rulesAssignFormAts
				v-if="isAccountRulesAssign"
				:subsidiary-id="currentSubsidiary.id"
				:customer-id="currentSubsidiary.customerId"
				:definition-id="definitionId"
				:module-id="moduleId"
				@close-modal="closeModal"
			/>
		</action-sidebar>
	</section>
</template>

<script>
import { ACCOUNTING_DEFINITION_REMOVE, ACCOUNTING_RULES_ASSIGN } from '@/shared/action-codes';
import actionBar from '@/components/shared/action-bar/action-bar';
import accountDefinitionsAtsList from '@/components/definitions-ats/definitions-list-ats';
import actionSidebar from '@/components/shared/action-sidebar';
import accountDefinitionsFormAts from '@/components/definitions-ats/definitions-ats-form';
import accountDefinitionsAtsRemove from '@/components/definitions-ats/definitions-ats-remove';
import rulesAssignFormAts from '@/components/definitions-ats/rules-ats-assign';
import { mapGetters } from 'vuex';
import permissions from '@/mixins/permissions';

async function loadData() {
	this.params.customerId = this.currentSubsidiary.customerId || null;
	this.params.subsidiaryId = this.currentSubsidiary.id || null;
	this.selectedRow.customerId = this.currentSubsidiary.customerId;
	this.selectedRow.subsidiaryId = this.currentSubsidiary.id;
	const { data: rows, headers } = await this.$http.get('transactional-definitions', { params: this.params });
	this.rows = rows.map((dc) => {
		const newDc = {
			id: dc.id,
			name: dc.name,
			code: dc.code,
			customerId: dc.customerId,
			moduleName: dc.module ? dc.module.name : '',
			subsidiaryId: dc.subsidiaryId,
			moduleId: dc.moduleId,
		};
		return newDc;
	});
	this.lastPage = Number(headers['x-last-page']);
	this.itemsTotalQuantity = Number(headers['x-quantity']);
	return this.rows;
}

function closeModal(reloadList) {
	this.action.code = '';
	this.action.title = '';
	this.action.visible = false;
	this.selectedRow.id = 0;
	if (reloadList) {
		loadData.call(this);
	}
}

function clickIcon({ action, row }) {
	// Guarda de seguridad: no permite editar/eliminar sin permiso.
	// (El listado ya oculta los iconos; esto es la segunda capa).
	if (action === 'edit' && !this.canEdit) return;
	if (action === 'delete' && !this.canDelete) return;
	this.selectedRow.customerId = row.customerId;
	this.selectedRow.subsidiaryId = row.subsidiaryId;
	this.selectedRow.id = row.id;
	this.selectedRow.name = row.name;
	if (action === 'edit') {
		this.action.title = `Editar - ${row.name}`;
		this.action.code = 'accouting-definition';
	} else if (action === 'delete') {
		this.action.code = ACCOUNTING_DEFINITION_REMOVE;
		this.action.title = `Eliminar - ${row.name}`;
	} else if (action === 'rules') {
		this.definitionId = row.id;
		this.moduleId = row.moduleId;
		this.action.title = `${row.name} / Asignar Reglas`;
		this.action.code = ACCOUNTING_RULES_ASSIGN;
	}
	this.action.visible = true;
}

async function created() {
	await loadData.call(this);
}

function customerId() {
	return Number(this.$route.query.customerId);
}

function isAccountDefinitionForm() {
	return this.action.code === 'accouting-definition';
}

function isAccountDefinitionRemove() {
	return this.action.code === ACCOUNTING_DEFINITION_REMOVE;
}

function isAccountRulesAssign() {
	return this.action.code === ACCOUNTING_RULES_ASSIGN;
}

function onPage(page) {
	this.params.page = page;
	loadData.call(this);
}

function onSearch(search) {
	this.params.page = 1;
	this.params.search = search;
	loadData.call(this);
}

function runAction({ name, code }) {
	this.action.title = name;
	this.action.code = code;
	this.action.visible = true;
	this.selectedRow.id = 0;
}

function subsidiaryId() {
	return Number(this.$route.query.subsidiaryId);
}

function title() {
	return `${this.$route.query.name} / ${this.$route.meta.title}`;
}

function currentSubsidiary(newSub) {
	const { id, name, customerId: idCustomer } = newSub;
	const newName = name.split(' ').join('-');
	this.goTo(
		'accouting-definition',
		{ query: { subsidiaryId: id, customerId: idCustomer, name: newName } },
	);
}

function routeHandler() {
	loadData.call(this);
}

function data() {
	return {
		action: {
			code: '',
			title: '',
			visible: false,
		},
		definitionId: null,
		itemsTotalQuantity: null,
		lastPage: 1,
		params: {
			customerId: null,
			limit: 10,
			page: 1,
			search: null,
			subsidiaryId: null,
		},
		selectedRow: {
			id: null,
			customerId: null,
			subsidiaryId: null,
		},
		rows: [],
		moduleId: null,
	};
}


export default {
	name: 'definitions-ats',
	mixins: [permissions],
	created,
	components: {
		actionBar,
		accountDefinitionsFormAts,
		accountDefinitionsAtsList,
		accountDefinitionsAtsRemove,
		actionSidebar,
		rulesAssignFormAts,
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
		customerId,
		isAccountDefinitionForm,
		isAccountDefinitionRemove,
		isAccountRulesAssign,
		subsidiaryId,
		title,
	},
	data,
	methods: {
		clickIcon,
		closeModal,
		onPage,
		onSearch,
		runAction,
	},
	watch: {
		currentSubsidiary,
		'$route.params': routeHandler,
	},
};
</script>



// WEBPACK FOOTER //
// src/pages/definitions-ats/page-definitions-ats.vue